export enum UnitType {
	Quantifier = 'Quantifier',
	Weight = 'Weight',
	Volume = 'Volume',
	Container = 'Container',
}
